// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2rEF1","header":"MergedInvoice_header__3PTUf"};